import React from 'react'

import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { PageGuardKSPNF } from 'app/KinerjaKepalaSKBPage/components/PageGuardKSPNF'
import BerandaKepalaSPNFPenilai from 'app/KinerjaKepalaSKBPage/page/Beranda'

import type { PageProps } from 'app/KinerjaShared/components/KinerjaLayout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled = toggle?.['kinerja-spnf-enabled'] || false

    if (!enabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
  },
})

const KinerjaIndex = ({ toggle }: PageProps) => {
  return (
    <PageGuardKSPNF>
      <BerandaKepalaSPNFPenilai
        isKinerjaPelaksanaanEnabled={toggle?.['kinerja-pelaksanaan-enabled']}
        isKinerjaPenilaianDemoEnabled={
          toggle?.['kinerja-penilaian-demo-mode-enabled']
        }
      />
    </PageGuardKSPNF>
  )
}

KinerjaIndex.Layout = KinerjaLayout

KinerjaIndex.layoutOpts = {
  hasHeader: true,
}

export default KinerjaIndex
